import { Level } from "./level.js"

export class Store extends Level {
    constructor(key, level, options) {
        if (new.target === Store) throw new TypeError("Cannot construct [Store] instances directly")
        super(key, level, { ...options, x: 3300, y: 400, background: "assets/store/background.jpg", music: "music-store" });
        this._layout = {
            ...this._layout, store: {
                article: [
                    {
                        "name": "bnlc-q-wall",
                        "positions": {"left": 45, "top": 33},
                    },
                    {
                        "name": "bnlc-s-wall",
                        "positions": {"left": 45, "top": 179},
                    },
                    {
                        "name": "bnlc-r-wall",
                        "positions": {"left": 3677, "top": 34},
                    },
                    {
                        "name": "bnlc-t-counter",
                        "positions": {"left": 183, "top": 1446},
                    },
                    {
                        "name": "bnlc-a-counter",
                        "positions": {"left": 480, "top": 399},
                    },
                    {
                        "name": "bnlc-f-counter",
                        "positions": {"left": 857, "top": 918},
                    },
                    {
                        "name": "bnlc-b-counter1",
                        "positions": {"left": 850, "top": 399},
                    },
                    {
                        "name": "bnlc-b-counter2",
                        "positions": {"left": 1167, "top": 654},
                    },
                    {
                        "name": "bnlc-c-counter1",
                        "positions": {"left": 1737, "top": 179},
                    },
                    {
                        "name": "bnlc-c-counter2",
                        "positions": {"left": 1520, "top": 399},
                    },
                    {
                        "name": "bnlc-c-counter3",
                        "positions": {"left": 1520, "top": 654},
                    },
                    {
                        "name": "bnlc-c-counter4",
                        "positions": {"left": 1658, "top": 785.5},
                    },
                    {
                        "name": "bnlc-d-counter1",
                        "positions": {"left": 2740, "top": 179},
                    },
                    {
                        "name": "bnlc-d-counter2",
                        "positions": {"left": 2530, "top": 309},
                    },
                    {
                        "name": "bnlc-d-counter3",
                        "positions": {"left": 2175, "top": 439},
                    },
                    {
                        "name": "bnlc-d-counter4",
                        "positions": {"left": 2175, "top": 694},
                    },
                    {
                        "name": "bnlc-d-counter5",
                        "positions": {"left": 2175, "top": 794},
                    },
                    {
                        "name": "bnlc-e-counter1",
                        "positions": {"left": 3323, "top": 674},
                    },
                    {
                        "name": "bnlc-e-counter2",
                        "positions": {"left": 3323, "top": 932},
                    },
                    {
                        "name": "bnlc-g-counter1",
                        "positions": {"left": 871, "top": 1446},
                    },
                    {
                        "name": "bnlc-g-counter2",
                        "positions": {"left": 1008, "top": 1688},
                    },
                    {
                        "name": "bnlc-g-counter3",
                        "positions": {"left": 1338, "top": 1297},
                    },
                    {
                        "name": "bnlc-g-counter4",
                        "positions": {"left": 1189, "top": 1297},
                    },
                    {
                        "name": "bnlc-h-counter1",
                        "positions": {"left": 1617, "top": 1184},
                    },
                    {
                        "name": "bnlc-h-counter2",
                        "positions": {"left": 1754, "top": 1184},
                    },
                    {
                        "name": "bnlc-h-counter3",
                        "positions": {"left": 1955, "top": 1331},
                    },
                    {
                        "name": "bnlc-i-counter",
                        "positions": {"left": 2195, "top": 1140},
                    },
                    {
                        "name": "bnlc-j-counter1",
                        "positions": {"left": 2877, "top": 1000},
                    },
                    {
                        "name": "bnlc-j-counter2",
                        "positions": {"left": 2877, "top": 1238},
                    },
                    {
                        "name": "bnlc-j-counter3",
                        "positions": {"left": 2913, "top": 1376},
                    },
                    {
                        "name": "bnlc-k-counter1",
                        "positions": {"left": 502, "top": 1947.5},
                    },
                    {
                        "name": "bnlc-k-counter2",
                        "positions": {"left": 183, "top": 2419},
                    },
                    {
                        "name": "bnlc-l-counter1",
                        "positions": {"left": 831, "top": 2320},
                    },
                    {
                        "name": "bnlc-l-counter2",
                        "positions": {"left": 831, "top": 2098},
                    },
                    {
                        "name": "bnlc-l-counter3",
                        "positions": {"left": 1338, "top": 2098},
                    },
                    {
                        "name": "bnlc-m-counter1",
                        "positions": {"left": 1652, "top": 2320},
                    },
                    {
                        "name": "bnlc-m-counter2",
                        "positions": {"left": 1652, "top": 2098},
                    },
                    {
                        "name": "bnlc-m-counter3",
                        "positions": {"left": 2035, "top": 2098},
                    },
                    {
                        "name": "bnlc-n-counter",
                        "positions": {"left": 2251, "top": 1858},
                    },
                    {
                        "name": "bnlc-o-counter",
                        "positions": {"left": 2245, "top": 2320},
                    },
                    {
                        "name": "bnlc-p-counter1",
                        "positions": {"left": 2877, "top": 1858},
                    },
                    {
                        "name": "bnlc-p-counter2",
                        "positions": {"left": 2877, "top": 2024},
                    },
                    {
                        "name": "bnlc-p-counter3",
                        "positions": {"left": 2877, "top": 2320},
                    },
                    {
                        "name": "bnlc-plant-1",
                        "positions": {"left": 692, "top": 2340},
                    },
                    {
                        "name": "bnlc-plant-2",
                        "positions": {"left": 1524, "top": 2340},
                    },
                    {
                        "name": "bnlc-plant-3",
                        "positions": {"left": 2117, "top": 2340},
                    },
                    {
                        "name": "bnlc-plant-4",
                        "positions": {"left": 2750, "top": 2340},
                    },
                    {
                        "name": "bnlc-plant-5",
                        "positions": {"left": 2925, "top": 32},
                    },
                    {
                        "name": "bnlc-plant-6",
                        "positions": {"left": 3081, "top": 32},
                    },
                    {
                        "name": "bnlc-plant-7",
                        "positions": {"left": 3242, "top": 32},
                    },
                    {
                        "name": "bnlc-plant-8",
                        "positions": {"left": 3400, "top": 32},
                    },
                    {
                        "name": "bnlc-plant-9",
                        "positions": {"left": 3546, "top": 32},
                    },
                ]
            }
        }
        this._articles = null;
    }
    preload(){
        super.preload()
        this.layout.store.article.forEach(a => this.load.image(a.name, `assets/store/article/${a.name}.png`))
    }
    create(){
        super.create()
        this._articles = this.physics.add.staticGroup()
        this.layout.store.article.forEach(a => {
            let so = this._articles.create(a.positions.left * this._scale.x, a.positions.top * this._scale.y, a.name)
                .setOrigin(0).setScale(this._scale.x, this._scale.y).refreshBody()
            so.setSize(so.body.width, so.body.height - 155 * this._scale.y, false)
        })
        this.physics.add.collider(this.bob, this._articles)
    }
}